@import (reference) '../../../../../constants/spacing.module.less';

.shipment-details-section-content {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  justify-content: center;
  gap: @space-8;

  padding: @space-0 @space-16 @space-16;
}

.column {
  flex: 1;
  gap: @space-12;
}

.return-counter {
  color: var(--default--text-color--15);
}

.header-container {
  flex: 1;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  gap: @space-16;
}
